import {
  FDBodyText,
  FDHeadlineText,
  FDStack,
} from '@facet-wealth/design';
import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import {
  TimelineItem, TimelineDot, TimelineConnector, TimelineSeparator, TimelineContent, TimelineOppositeContent,
} from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Timeline';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

export const TermSectionListItemLayout = ({ isLastSection = false }) => {
  const { resource } = useMetaLayoutContext();
  const theme = useTheme();

  if (!resource) {
    return null;
  }

  const items = resource.attr('items');
  if (!items) {
    return null;
  }

  return (
    <TimelineItem
      sx={{
        flex: 0,
        padding: 0,
        margin: 0,
      }}
    >
      <TimelineOppositeContent style={{ display: 'none' }} />
      <TimelineSeparator>
        <TimelineDot variant="outlined" style={{ borderColor: theme.palette.facet.oceana800 }} />
        { !isLastSection ? <TimelineConnector
          style={{
            borderLeftColor: theme.palette.facet.oceana800,
            borderLeftStyle: 'dashed',
            borderLeftWidth: '1px',
            backgroundColor: theme.palette.facet.lightGray,
          }}
        /> : null }
      </TimelineSeparator>
      <TimelineContent style={{ paddingBottom: `${!isLastSection ? '48px' : '0px'}`, paddingTop: '0px' }}>
        <FDStack direction={'column'} spacing={1} {...dataAttrs('term-section-list')}>
          <FDHeadlineText value={resource.attr('title')} size={'sm'} />
          <ul style={{ margin: '0px' }}>
            {items.map((item) => (
              <li {...dataAttrs('term-section-list-item')}>
                <FDBodyText value={item} />
              </li>))}
          </ul>
        </FDStack>
      </TimelineContent>
    </TimelineItem>
  );
};
